/** Filtro da lista que cada número do funil aplica (spec 29 R3, R4). */
export const FILTRO_FUNIL = {
  naCampanha: {},
  convidados: { convite: 'enviado' },
  acessaram: { acessou: 'sim' },
  responderam: { respondeu: 'sim' },
  naoConvidados: { convite: 'nao_enviado' },
  falhas: { convite: 'falha' },
  naoAcessaram: { acessou: 'nao' },
  pararamNoMeio: { acessou: 'sim', respondeu: 'nao' },
} as const satisfies Record<string, Record<string, string>>;

export type NumeroFunil = keyof typeof FILTRO_FUNIL;

/**
 * Só o filtro dado: substitui todos os outros (R3). `situacao` e `pagina` ficam de fora porque
 * os padrões da lista já são `elegivel` e 1. A lista está na página da fase (spec 36 R12).
 */
export const buscaDoFunil = (filtro: Record<string, string>) => `?${new URLSearchParams(filtro)}`;

export const porcentagem = (parte: number, total: number) => Math.round((parte / total) * 100);
